import React, { createContext } from "react";
import { defaultNewPlanningOptions, NewPlanningOptions } from "./types";
import { NewPlanningModal } from "./NewPlanningModal";

interface PlanningContextValue {
  open: (opts: Partial<NewPlanningOptions> | null) => void
  openWithExistingOptions: () => void
  setOpts: (opts: Partial<NewPlanningOptions> | null) => void
  opts: NewPlanningOptions | null
}

const defaultPlanningContext: PlanningContextValue = {
  open: () => { },
  openWithExistingOptions: () => { },
  setOpts: () => { },
  opts: null
};

export const PlanningContext = createContext<PlanningContextValue>(defaultPlanningContext);

export const PlanningProvider = (props: React.PropsWithChildren) => {
  const [isOpen, setIsOpen] = React.useState(false);
  const [options, setOptions] = React.useState<NewPlanningOptions | null>(null);

  const open = (opts: Partial<NewPlanningOptions> | null) => {
    setOpts({ ...options, ...opts });
    setIsOpen(true);
  }

  const setOpts = (opts: Partial<NewPlanningOptions> | null) => {
    if (opts === null) {
      setOptions(null);
      return;
    }

    setOptions({ ...defaultNewPlanningOptions, ...opts });
  }

  const onClose = () => {
    setIsOpen(false);
  }

  return <PlanningContext.Provider value={{
    open,
    openWithExistingOptions: () => open(options),
    setOpts,
    opts: options
  }}>
    {props.children}
    <NewPlanningModal
      isOpen={isOpen}
      options={options}
      onClose={onClose}
    />
  </PlanningContext.Provider>
}